// extracted by mini-css-extract-plugin
export default {"modal":"MoveResourceModal-module__modal__auqmy","content":"MoveResourceModal-module__content__DYnvB","alert":"MoveResourceModal-module__alert__eLogA"};